import { gql } from "../../../__generated__/gql";

export const GET_POST = gql(`
query post($id: String!) {
  post (where: {id: $id}){
    id
    date
    description
    image
    title
    socials
    pollId
    aspect
    links
  }
}
`);

export const UPDATE_POST = gql(`
mutation updatePost($id: String!, $title: String!, $description: String!, $date: String!, $image: String!, $socials: JSON, $pollId: String,$aspect: Float!) {
  updatePost(post: { id: $id, title: $title, description: $description, date: $date, image:$image, socials: $socials, pollId: $pollId, aspect: $aspect }) {
    id
  }
}
`);

export const UPDATE_POST_LINKS = gql(`
mutation updatePostLinks($id: String!, $links: JSON) {
  updatePost(post: { id: $id, links: $links }) {
    id
    links
  }
}
  `);

export const CREATE_POST = gql(`
mutation createPost($title: String!, $description: String!,$date: DateTime!, $image: String!, $socials: JSON) {
  createPost(title: $title, description: $description, date: $date, image: $image, socials: $socials ) {
    id
  }
}
`);

export const EXPORT_POST = gql(`mutation exportPost($postId: String!) {
  exportPost(postId: $postId)
}`);

export const DELETE_POST = gql(`mutation deletePost($postId:String!) {
  deletePost(postId: $postId){
    id
  }
}`);

export const GET_POLL = gql(`
  query poll($id: String!) {
    poll(where: {id: $id}){
      id
      title
      values
      expiryDate
      choices
      posts {
        id
        title
      }
    }
  }
  `);

export const GET_POLL_RESULT = gql(`
query pollResults($id: String!) {
    pollResults(id: $id)  {
      title
      totalResponses
      results {
        option
        count
      }
      
    }
  
}
    `);

export const UPSERT_POLL = gql(`
mutation upsertPoll($id: String, $title: String!, $values: [String!]!, $expiryDate: String!, $choices: Int!) {
    upsertPoll(id: $id, title: $title, values: $values, expiryDate: $expiryDate, choices: $choices) {
      id
      title
      values
      expiryDate
      choices
      posts {
        id
        title
      }
    }
}
    `);

export const DELETE_POLL = gql(`
      mutation deletePoll($pollId: String!) {
          deletePoll(pollId: $pollId) 
}
          `);
